/**
 * Created by rathompson on 2/8/22
 * File: constants
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

export const PROVISIONING_STATUSES = Object.freeze({
  ERROR: 'error',
  INITIALIZING: 'initializing',
  PROVISIONING: 'provisioning',
  COMPLETE: 'complete'
})
